import { CertificationInput as CertificationInputDto } from "src/app/proxy/certifications/models";

export class CertificationInput {
  id: number;
  projectId: number;
  activityReportId: string;
  roadId: number;
  resourceId: number;
  activityGroupId: number;
  activityReportActivityId: number;
  resourceName: string;
  quantity: number;
  deleted: boolean;
  updated: string;
  version: number;
  operation: string;

  constructor(dto: CertificationInputDto = {}) {
    Object.assign(this, dto);
  }
}
